import { createPostEndpoint } from '@sonar-software/sonar-http';

export const postApiGatewayKeys = createPostEndpoint(
	'/api/v3/security/api-gateway-keys'
);
